import { ref } from 'vue'
import firebase from '../../firebase'
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore'

const getOrders = () => {
  const orders = ref([])

  const loadOrders = async (uid) => {
    try {
      const ordersRef = collection(firebase.db, 'orders')
      const q = query(ordersRef, where('uid', '==', uid), orderBy('date', 'desc'))
      const querySnapshot = await getDocs(q)

      querySnapshot.forEach((doc) => {
        orders.value.push({
          ...doc.data(),
          id: doc.id
        })
      })
    } catch (error) {
      console.log(error)
    }
  }
  return { orders, loadOrders }
}
export default getOrders
